import { render, staticRenderFns } from "./UserScientificDegrees.vue?vue&type=template&id=5e8f5954&"
import script from "./UserScientificDegrees.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports